export default "__VITE_ASSET__DgMUwfKx__"